import {Maybe, Member} from '@progyny/generated/graphql'
import {
  FERTILITY,
  MENOPAUSE,
  PREGNANCY_AND_POSTPARTUM,
} from '@progyny/utils/constants'

import {UNSET} from '../const'

function _evaluateFertilityProfile(member: Maybe<Member>): boolean {
  if (!member) return false
  if (member.birthAssignedSex === UNSET) return false
  if (member.genderIdentity === UNSET) return false
  if (member.relationshipDynamic === UNSET) return false
  return member.familyFormingJourney !== UNSET
}

function _evaluateMenopauseProfile(member: Maybe<Member>): boolean {
  if (!member) return false
  const j = member.menopauseJourney
  if (
    !j?.menstrualPeriodStatus ||
    j.menstrualPeriodStatus === UNSET ||
    j.menstrualPeriodStatus === 'unset'
  )
    return false
  if (
    !j.lastMenstrualPeriod ||
    j.lastMenstrualPeriod === UNSET ||
    j.lastMenstrualPeriod === 'unset'
  )
    return false
  if (
    !j.menopauseSymptoms ||
    !Array.isArray(j.menopauseSymptoms) ||
    j.menopauseSymptoms.length === 0 ||
    j.menopauseSymptoms.every((s) => s === UNSET || s === 'unset' || !s)
  )
    return false
  return true
}

function _evaluatePregnancyPostpartumProfile(member: Maybe<Member>): boolean {
  if (!member) return false
  const j = member.pregnancyPostpartumJourney
  if (
    !j?.pregnancyPostpartumStatus ||
    j.pregnancyPostpartumStatus === UNSET ||
    j.pregnancyPostpartumStatus === 'unset'
  )
    return false
  if (j.pregnancyPostpartumStatus === 'pregnant')
    return !!(j.dueDate && j.dueDate !== '' && j.dueDate != null)
  if (j.pregnancyPostpartumStatus === 'postpartum')
    return !!(j.deliveryDate && j.deliveryDate !== '' && j.deliveryDate != null)
  return false
}

export function evaluateProfileForProductLine(
  member: Maybe<Member>,
  productLine?: string
): boolean {
  if (!member) return false
  const active = productLine || member.activeMemberJourney || FERTILITY
  switch (active) {
    case MENOPAUSE:
      return _evaluateMenopauseProfile(member)
    case PREGNANCY_AND_POSTPARTUM:
      return _evaluatePregnancyPostpartumProfile(member)
    case FERTILITY:
    default:
      return _evaluateFertilityProfile(member)
  }
}
